import React from 'react'
import { component_tool, framework_tool } from '../../../../tool';
import { WizTableForm } from '@/containers/common';

let { WizPopover } = component_tool;
let componentName = 'labelUser'

const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1 } })

const columns = (pushProps = {}) => {
    let labelInfo = pushProps
    return [
        {
            name: 'id',
            formItem: {
                type: 'hidden'
            }
        },
        {
            name: 'labelId',
            formItem: {
                type: 'hidden',
                initialValue: labelInfo?.id
            }
        },
        {
            title: '标签',
            name: 'labelName',
            formItem: {
                disabled: true,
                initialValue: labelInfo?.name
            }
        },
        {
            name: 'source',
            formItem: {
                type: 'hidden',
                initialValue: 2
            }
        },
        {
            title: '学员账号',
            name: 'userName',
            searchItem: {},
        },
        {
            title: '学员姓名',
            name: 'fullName',
            searchItem: {},
        },
        {
            title: '是否完成课程',
            name: 'completeType',
            searchItem: { type: 'select',},
            dict: [
                { code: 0, codeName: '否' },
                { code: 1, codeName: '是' },
            ]
        },
        {
            title: '标签名称',
            name: 'labelNames',
            searchItem: {
                disabled: true,
                formatInit: () => labelInfo?.name || ''
            },
        },
        {
            title: '标签名称',
            name: 'labelName',
            tableItem: {},
        },
        {
            title: '标签编码',
            name: 'labelCodes',
            searchItem: {
                disabled: true,
                formatInit: () => labelInfo?.code || ''
            },
        },
        {
            title: '标签编码',
            name: 'labelCode',
            tableItem: {},
        },
        {
            title: '标签状态',
            name: 'labelState',
            tableItem: {},
            dict: [
                { code: 0, codeName: '无效' },
                { code: 1, codeName: '有效' }
            ]
        },
        {
            title: '学员账号',
            name: 'userName',
            tableItem: {},
        },
        {
            title: '学员姓名',
            name: 'fullName',
            tableItem: {},
        },
        {
            title: '任职信息',
            name: 'identityLists',
            tableItem: {
                render: (val = [], record) => {
                    if (!val.length) { return '暂无任职' }
                    let { orgName, positionName } = val[0]
                    let _titleView = [`${orgName}-${positionName}`]
                    if (val.length > 1) {
                        _titleView.push(<span className='manager-person-text-color'> ...</span>)
                    }
                    return (
                        <WizPopover
                            content={val.map((e) => <p>{`${e['orgName']}-${e['positionName']}`}</p>)}
                            placement="rightTop"
                        >
                            {_titleView}
                        </WizPopover>
                    )
                }
            },
        },
        {
            title: '学员',
            name: 'personId',
            formItem: {
                ...userConfig,
                diy: WizTableForm,
                selectType: 'radio',
                rules: [{
                    required: true,
                    message: '请选择学员',
                }]
            },
        },
        {
            title: '贴标时间',
            name: 'operationTime',
            tableItem: {},
            formItem: {
                type: 'datetime',
                rules: [{ required: true, message: '请选择贴标时间' }]
            }
        },
        {
            title: '是否推送课程',
            name: 'pushType',
            tableItem: {},
            dict: [
                { code: 0, codeName: '否' },
                { code: 1, codeName: '是' },
            ]
        },
        {
            title: '是否完成课程',
            name: 'completeType',
            tableItem: {},
            dict: [
                { code: 0, codeName: '否' },
                { code: 1, codeName: '是' },
            ]
        },
        {
            title: '完成时间',
            name: 'completeTime',
            tableItem: {},
        },
        {
            title: '是否撕除标签',
            name: 'tearType',
            searchItem: {
                type: 'select',
                formatInit: () => 0
            },
            tableItem: {},
            dict: [
                { code: 0, codeName: '否' },
                { code: 1, codeName: '是' },
            ]
        },
        {
            title: '用户贴标状态',
            name: 'state',
            searchItem: {
                type: 'select',
                formatInit: () => 1
            },
            tableItem: {},
            dict: [
                { code: 1, codeName: '有效' },
                { code: 0, codeName: '无效' },
            ]
        },
    ];
}

const templateConfig = (data) => {
    let { pushProps } = data
    return {
        mainProps: {},
        content: {
            name: "WizTableList",
            params: {
                columns: columns(pushProps),
                searchBarProps: {
                    buttonSort: ['add', 'import', 'export'],
                    buttons: [
                        {
                            key: 'import',
                            custom: true,
                            params: { icon: 'import', children: '导入' },
                            customOnClick: {
                                key: 'jumpPage',
                                params: {
                                    key: 'push',
                                    pathname: '/biz/label/labelUser/import',
                                    record: {labelId: pushProps.id}
                                }
                            }
                        },
                        {
                            key: 'export',
                            custom: true,
                            params: { icon: 'export', children: '导出标签用户', type: 'export' },
                            customOnClick: {
                                key: 'action',
                                params: {
                                    apiKey: "export",
                                    apiParams: {}
                                },
                                formatParams: (rows, record, filters, callback) => {
                                    return { ...filters }
                                }
                            }
                        }
                    ],
                    dataFormat: (v) => {
                        let value = Object.assign([], v)
                        value['state'] = value['state'] == 0 ? '0' :value['state'];
                        return value
                      },
                },
                modalFormProps: {},
                dataTableProps: {
                    rowKey: "id",
                    selectType: "checkbox",
                    isScroll: true,
                    bordered: false,
                    paging: false,
                    loading: false
                },
                rowOperateSort: ['look'],
                rowOperateView: [
                    {
                        key: "look",
                        custom: true,
                        params: { children: "查看" },
                        customOnClick: {
                            key: "jumpPage",
                            params: {
                                key: "push",
                                pathname: "/biz/label/labelUser/look"
                            }
                        }
                    },
                ],
                rowOperateProps: {
                    width: 80,
                    fixed: 'right',
                  },
                commonOperate: {
                    add: true,
                }
            }
        }
    }
};

const apis = (labelId = []) => {
    return {
        list: {
            path: `${componentName}/list`,
            payload: {
                key: `${componentName}@list`,
                apiParams: { labelId: labelId, tearType: 0, state: 1 }
            }
        },
        add: {
            path: `${componentName}/add`,
            payload: {
                key: `${componentName}@add`,
                apiParams: {}
            }
        },
        export: {
            path: `${componentName}/export`,
            payload: {
                key: `${componentName}@export`,
                apiParams: { labelId: labelId, tearType: 0, state: 1 }
            }
        }
    }
}

let reduxTemplateConfig = (args) => {
    let { labelId } = args
    return {
        apis: apis(labelId),
        componentName,
        initApiKeys: ['list'],
        keepInitApiParams: true,
        needLoading: true,
        ...args
    }
};

export { reduxTemplateConfig, templateConfig };
